<template>
  <BaseSimpleTab :tabs="tabs" />
  <div class='mt-5'>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'TheCompanyInfoPage',
  data() {
    return {
      tabs: [
        {label: this.$t('global.general_information'), icon: 'info-square', routeName: 'settings_edit_company_route'},
        {label: this.$t('global.activities'), icon: 'file-alt', routeName: 'settings_company_activity_route'},
      ]
    }
  }
}
</script>

